import {EventViewModel} from "../../../../../domain/common/events/models/event-view-model";
import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";

export class MatchEventsModuleRowViewModel extends BaseViewModel {
  stageId: Number = null;
  gameTime: Number = null;
  addedTime: Number = null;
  homeEvent: EventViewModel = null;
  awayEvent: EventViewModel = null;
  isNationalTeam: Boolean = false;
  visible: Boolean = false;

  constructor(homeEvent: EventViewModel, awayEvent: EventViewModel, isNationalTeam = false) {
    super();

    this.stageId = homeEvent ? homeEvent.stageId : awayEvent.stageId;
    this.gameTime = homeEvent ? homeEvent.gameTime : awayEvent.gameTime;
    this.addedTime = homeEvent ? homeEvent.addedTime : awayEvent.addedTime;
    this.sortIndex = homeEvent ? homeEvent.order : awayEvent.order;
    this.homeEvent = homeEvent;
    this.awayEvent = awayEvent;
    this.isNationalTeam = isNationalTeam;
    this.visible = false;
  }

  get isMajor(): Boolean {
    const isMajor: Boolean = (this.homeEvent && this.homeEvent.isMajor) || (this.awayEvent && this.awayEvent.isMajor)

    return isMajor;
  }

  get gameTimeDisplay(): String {
    const gameTime: String = this.homeEvent ? this.homeEvent.gameTimeDisplay : this.awayEvent.gameTimeDisplay
    const gameTimeDisplay: String = gameTime + (this.addedTime ? ` + ${this.addedTime}` : '')

    return gameTimeDisplay;
  }

  get isNewEvent(): Boolean {
    const isNewEvent: Boolean = this.homeEvent?.isNew || this.awayEvent?.isNew;

    return isNewEvent;
  }

  get order(): Number {
    return this.homeEvent?.order || this.awayEvent?.order;
  }
}
